export default __webpack_public_path__ + "static/media/98.3ebbae43.gif";